import { Link, useLoaderData } from "@remix-run/react";
import { useTranslation } from "react-i18next";
import BlogBox from "~/components/blog/BlogBox";
import { loader } from "./route";
import { CategoryType } from "~/utils/data/categories";
import { EMAIL_SUBSCRIBED_STORAGE } from "~/utils/constants";
import useLocalStorage from "~/utils/hooks/useLocalStorage";
import { useState } from "react";
import SubscribeEmailPopup from "~/components/blog/SubscribeEmailPopup";

export default function Webinar() {
  const { blog, locale, otherWebinars } = useLoaderData<typeof loader>();
  const { t } = useTranslation("blog");

  const [subscribed, setSubscribed] = useLocalStorage(
    EMAIL_SUBSCRIBED_STORAGE,
    false,
  );

  const [showForm, setShowForm] = useState(false);

  return (
    <div>
      <BlogBox
        blog={blog}
        imgRatio="hidden"
        className=""
        locale={locale}
        page={true}
      />
      {showForm && !subscribed && (
        <div className="fixed left-0 top-0 z-50 flex h-full w-full items-center justify-center">
          <div
            className="absolute left-0 top-0 h-full w-full bg-black bg-opacity-50"
            onClick={() => setShowForm(false)}
          ></div>
          <SubscribeEmailPopup title="enterEmailVideo" button="watchNow" />
        </div>
      )}
      <div className="mt-7 flex flex-col gap-5 lg:flex-row">
        <div className="relative rounded-3xl bg-gray-100 p-2 md:p-6 lg:flex-[2]">
          <div className="relative">
            {!subscribed && (
              <div
                className="absolute left-0 top-0 z-20 flex h-full w-full cursor-pointer items-center justify-center"
                onClick={() => setShowForm(true)}
              >
                <PlaySVG />
              </div>
            )}
            <video
              className="relative z-10  aspect-[17/10] w-full rounded-2xl"
              controls={subscribed}
            >
              <source
                src={blog.attributes.video?.data?.attributes.url}
                type="video/mp4"
              />
              <source src="/videos/home.mp4" type="video/mp4" />
            </video>
          </div>
        </div>
        <OtherWebinars />
      </div>
    </div>
  );
}

function OtherWebinars() {
  const { locale, otherWebinars } = useLoaderData<typeof loader>();
  const { t } = useTranslation("blog");

  return (
    <div className="rounded-xl border border-Light-grey-Lg-100 p-2 md:p-6 lg:flex-1">
      <div className="flex items-center justify-between border-b border-b-Light-grey-Lg-100 pb-[18px]">
        <p className="text-Secondary-Dark-Blue-db-700">{t("otherWebinars")}</p>
        <Link
          to={`/blogs/${CategoryType.Webinars}`}
          className="text-xs text-Primary-Magic-Mint-Mm-600"
        >
          {t("seeAll")}
        </Link>
      </div>
      <div className="divide-y">
        {otherWebinars?.map((webinar) => (
          <BlogBox
            blog={webinar}
            imgRatio="aspect-square h-[90px]"
            className="py-6"
            locale={locale}
            describe={false}
            row={true}
          />
        ))}
      </div>
    </div>
  );
}

function PlaySVG() {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.9369 4.16669C13.4368 4.16669 4.10352 13.5 4.10352 25C4.10352 36.5 13.4368 45.8334 24.9369 45.8334C36.4369 45.8334 45.7702 36.5 45.7702 25C45.7702 13.5 36.4577 4.16669 24.9369 4.16669ZM31.1869 29.6459L25.1452 33.125C24.3952 33.5625 23.5618 33.7709 22.7493 33.7709C21.916 33.7709 21.1035 33.5625 20.3535 33.125C18.8535 32.25 17.9577 30.7084 17.9577 28.9584V21.9792C17.9577 20.25 18.8535 18.6875 20.3535 17.8125C21.8535 16.9375 23.6452 16.9375 25.166 17.8125L31.2077 21.2917C32.7077 22.1667 33.6035 23.7084 33.6035 25.4584C33.6035 27.2084 32.7077 28.7709 31.1869 29.6459Z"
        fill="white"
      />
    </svg>
  );
}
